import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class Surface extends HObject {
  static meshes = []
  static loadRequest = false
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    Surface.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/Surface/', 'surface.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
        //  container.meshes[i].name = 'original.outdoor.surface.' + container.meshes[i].name
      }
      hObject.lod(container.meshes, 1000)
      container.addAllToScene()

      Surface.meshes = container.meshes
    })
  }

  register () {
    if (Surface.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < Surface.meshes.length; i++) {
        newInstances.push(Surface.meshes[i].createInstance(Surface.meshes[i].name))
      }

      for (let i = 0; i < Surface.meshes.length; i++) {
        if (Surface.meshes[i].name !== 'root') {
          newInstances.push(Surface.meshes[i].createInstance(Surface.meshes[i].name + '_B'))
          newInstances[newInstances.length - 1].rotation.y = -90 * Math.PI / 4
        }
      }

      for (let i = 0; i < Surface.meshes.length; i++) {
        if (Surface.meshes[i].name !== 'root') {
          newInstances.push(Surface.meshes[i].createInstance(Surface.meshes[i].name + '_C'))
          newInstances[newInstances.length - 1].rotation.y = -180 * Math.PI / 4
        }
      }

      for (let i = 0; i < Surface.meshes.length; i++) {
        if (Surface.meshes[i].name !== 'root') {
          newInstances.push(Surface.meshes[i].createInstance(Surface.meshes[i].name + '_D'))
          newInstances[newInstances.length - 1].rotation.y = -270 * Math.PI / 4
        }
      }

      this.objectConfigurations(newInstances)
      this.setup()
    } else {
      if (Surface.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setup () {

  }
}



// WEBPACK FOOTER //
// ./src/hobjects/Surface.js